// Client V2 common imports
const {
  ARTICLE_MIXES_UPDATED
} = require('client-v2/common/models/article/actions')
// Container imports
const { loadCollections } = require('./slide-actions')
const { getCurrentModalSlide } = require('./selectors')

function articleProfileMiddleware() {
  return store => {
    return next => action => {
      if (action.type === ARTICLE_MIXES_UPDATED) {
        const { urlId } = action.payload
        const state = store.getState()
        maybeUpdateSlide(state.articleProfile, urlId)
        maybeUpdateSlide(getCurrentModalSlide(state), urlId)
      }
      next(action)
    }
    function maybeUpdateSlide(slide, urlId) {
      if (slide && slide.article['url_id'] === urlId) {
        store.dispatch(loadCollections({ article: slide.article }))
      }
    }
  }
}

module.exports = articleProfileMiddleware
